import SnapSlider from '@tannerhodges/snap-slider'; //import the class for the in content slider
import './swiped-events.min.js';

const sliderElements = {};
const slider = new SnapSlider('.content-slider', {
  loop: true,
  on:  {
    'load': () => {
      slider.slides[slider.current].classList.add('scale');
    },
    'scroll.end': () => {
      slider.slides.forEach(slide => slide.classList.remove('scale'));
      const zoomSlide = slider.slides[slider.current] || slider.slides[slider.current - 2];
      zoomSlide.classList.add('scale');
    }
  }
});

/**
 * @description initialize slider navigation events and reference elements.
 */
const init = () => {
  bindSliderElements();
  bindSliderNav();
};

/**
 * @description attach slider elements.
 */
const bindSliderElements = () => {
  sliderElements.navArrows = document.querySelectorAll('[data-snap-arrow]');
  sliderElements.dotbtns = document.querySelectorAll('[data-snap-dot] button');
  sliderElements.dots = document.querySelectorAll('[data-snap-dot]');
  sliderElements.sliderContainer = document.querySelector('.content-slider');
}

/**
 * @description bind slider navigation for arrows and dots.
 * In desktop each navigation should cycle to the third slide.
 * In mobile bind navigation to dots to cycle to next slide.
 */
const bindSliderNav = () => {
  let isDesktop = (window.innerWidth > 999) ? true : false;
  sliderElements.navArrows.forEach((navArrow) => {
    const arrowDirec = navArrow.dataset.snapArrow;
    if ( isDesktop ) {
      sliderElements.dotbtns.forEach((dot,index,list) => {
        if (slider.current === 1 && index === 0) {
          list[index].classList.add('is-current');
          list[index + 1].classList.add('is-current');
          list[index + 2].classList.add('is-current');
        }  
      })
     
      if( arrowDirec === "next") {
        navArrow.addEventListener('click', () => {
          slider.goto(slider.current + 3);
          clearDotHighlight();
          addDotHighlight(); 
        });
      } else { 
        navArrow.addEventListener('click', () => {
          slider.goto(slider.current - 3);
          clearDotHighlight();
          addDotHighlight();
        })
      };  
    }
  }); 

  if (!isDesktop) {
    mobileNavDots();
  }
  
  swipedLeft();
  swipedRight();
};

/**
 * @function swipedLeft
 * @description Functionality for swiping left
*/
const swipedLeft = () => {
  sliderElements.sliderContainer.addEventListener('swiped-left', () => {
    slider.goto(slider.current + 1);
    swipDotHighlight();
  });
}

/**
 * @function swipedRight
 * @description Functionality for swiping right
*/
const swipedRight = () => {
  sliderElements.sliderContainer.addEventListener('swiped-right', () => {
    slider.goto(slider.current - 1);
    swipDotHighlight();
  });
}

/**
 * @description highlight dots on swip event.
 */
const swipDotHighlight = () => {
  clearDotHighlight();
  sliderElements.dotbtns.forEach((dot,index, list) => {
    if (slider.current === 1 && index === 0) {
      list[index].classList.add('is-current');
    } else if (slider.current !== 1) {
      list[slider.current - 1].classList.add('is-current'); // slider.current -1 in order to match the index number
    };
  });
};

/**
 * @function mobileNavDots
 * @description Functionality for nav dots in mobile
*/
const mobileNavDots = () => {
  sliderElements.dots.forEach( (dot) => {
    dot.addEventListener('click', () => {
      const index = dot.dataset.snapDot;
      clearDotHighlight();
      dot.querySelector('button').classList.add('is-current');
      slider.goto(index);
    });
  });
};

/**
 * @function addDotHighlight
 * @description Sets the number of dots in the nav to be highlighted 
*/
const addDotHighlight = () => {
  if(slider.current + 2 < slider.slides.length) {
    sliderElements.dotbtns.forEach((dot,index,list) => {
      list[slider.current - 1].classList.add('is-current');
      list[slider.current].classList.add('is-current');
      list[slider.current + 1].classList.add('is-current');  
    });
  } else {
    sliderElements.dotbtns.forEach((dot,index,list) => {
      list[slider.current - 1].classList.add('is-current');
      list[slider.current - 2].classList.add('is-current');
      list[slider.current - 3].classList.add('is-current');
    });
  }
};

/**
 * @function clearDotHighlight
 * @description Removes the highlight of the nav dots.
*/
const clearDotHighlight = () => {
  sliderElements.dotbtns.forEach( (dot) => {
    dot.classList.remove('is-current');
  });
};

export default init;